import { render, staticRenderFns } from "./KidsHome.vue?vue&type=template&id=51d03d5a&scoped=true&"
import script from "./KidsHome.vue?vue&type=script&lang=js&"
export * from "./KidsHome.vue?vue&type=script&lang=js&"
import style0 from "./KidsHome.vue?vue&type=style&index=0&id=51d03d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d03d5a",
  null
  
)

export default component.exports